import {
  SpoModelsResponseItem,
  SpoPersonalOfferTableResponseDataItem,
} from '@spo/types';

import { ObjectValues } from './enum';

export type TableDataWithImage = SpoPersonalOfferTableResponseDataItem & {
  imageURL: string;
};

export enum TableType {
  superModel = 'supermodel',
  model = 'model',
}

export type TableDataType =
  | SpoModelsResponseItem
  | SpoPersonalOfferTableResponseDataItem;

export const ORDER_VALUE = {
  ASC: 'asc',
  DESC: 'desc',
  EMPTY: '',
};

export type OrderValue = ObjectValues<typeof ORDER_VALUE>;

export type ColumnSort = {
  id: string;
  order: OrderValue;
};

export type Range = {
  start: number;
  end: number;
};
